module.exports = __webpack_public_path__ + "img/ic-landing-wallet.6b496d3b.svg";